import { useEffect, useRef, useState } from "react";
import {
  Button,
  DownloadButton,
  LoadingComponent,
  Modal,
  MultiSelect,
  NoDataFoundTemplate,
  Select,
} from "../../../components/core";
import { ContentContainer } from "../../../components/layout";
import { useLazyQuery, useQuery } from "@apollo/client";
import { QUERY_LOCKER_TYPE } from "../../../features/locker-rental-report/locker-rental-graphql";
import { QUERY_COMPANY_NKCNAME } from "../../../constants/graphql/POD-queries";
import { LOCKER_INFO } from "../../../constants/graphql/locker-queries";
import { USER_TYPE_FOR_LOCKER_STORAGE_FEES } from "../../../constants/graphql/locker-storage-fees-query";
import StorageRentalTable from "./StorageRentalTable";
import {
  AGGREGATE_STORAGE_FEES,
  STORAGE_RENTAL_FEES_QUERY,
} from "../../../constants/graphql/storage-rental-fees-queries";
import {
  FILTER_PACKAGES,
  LOCKER_USER_ACCOUNTS_FOR_VIEW_PACKAGE_HISTORY,
} from "../../../constants/graphql/view-package-history-queries";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { InputText } from "primereact/inputtext";
import { getSixMonthsAgo, toUTCDateTimeString } from "../../../algorithms/date";
import AggregateStorageRentalFeesTable from "./aggregate-storage-rental-table";
import TransactionCard from "../overstay-fees-report/transaction-card";
import { formatDate as globalFormatDate } from "../../../algorithms/date";
import { NEWEST_LOCKER_NAME_QUERY } from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import { paymentCurrency } from "../overstay-fees-report";
import { Card } from "primereact/card";
import {
  computeAggregate,
  computeAggregateFromBackend,
  doorSizeOptions,
} from "../../../utils/compute-aggregate";
const StorageRentals = () => {
  // LOCAL storage
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const dt = useRef(null);

  const [lockerType, setLockerType] = useState([]);
  const [selectedLockerType, setSelectedLockerType] = useState("-1");
  const [lockerName, setLockerName] = useState([]);
  const [numberFilter, setNumberFilter] = useState("");
  const [waybillNumFilter, setWaybillNumberFilter] = useState("");

  const [userTypes, setUserTypes] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState("-1");
  const [partnerCompany, setPartnerCompany] = useState([]);
  const [selectedPartnerCompany, setSelectedPartnerCompany] = useState("-1");
  const [partnerBranches, setPartnerBranch] = useState([]);
  const [selectedPartnerBranch, setSelectedPartnerBranch] = useState("-1");
  // const [startDate, setStartDate] = useState(() => {
  // 	const today = new Date();
  // 	today.setMonth(today.getMonth() - 3);
  // 	return today;
  // });
  const [startDate, setStartDate] = useState(new Date("2024-01-01"));
  const [endDate, setEndDate] = useState(new Date());
  const [searchResultHeader, setSearchResultHeader] = useState("");
  const [allPaymentDate, setAllPaymentDate] = useState(true);
  const [totalAmt, setTotalAmt] = useState({
    php: 0,
    coins: 0,
  });
  const [totalTransactions, setTotalTransactions] = useState({
    php: 0,
    coins: 0,
  });
  const [totalSuccessTrans, setTotalSuccessTrans] = useState({
    storage: {
      php: 0,
      coins: 0,
    },
    dropOff: {
      php: 0,
      coins: 0,
    },
    subtotal: 0,
  });
  const [totalDuplicates, setTotalDuplicates] = useState({
    storage: { php: "0.00", coins: "0.00" },
    dropOff: { php: "0.00", coins: "0.00" },
    subtotal: { php: "0.00", coins: "0.00" },
  });
  const [totalRefunded, setTotalRefunded] = useState({
    storage: { php: "0.00", coins: "0.00" },
    dropOff: { php: "0.00", coins: "0.00" },
    subtotal: { php: "0.00", coins: "0.00" },
  });
  const [totalGrossSales, setTotalGrossSales] = useState({
    storage: { php: "0.00", coins: "0.00" },
    dropOff: { php: "0.00", coins: "0.00" },
    subtotal: { php: "0.00", coins: "0.00" },
  });
  const [totalFailedTrans, setTotalFailed] = useState({
    storage: {
      php: 0,
      coins: 0,
    },
    dropOff: {
      php: 0,
      coins: 0,
    },
    subtotal: 0,
  });

  const transActStatus = [
    { value: "1", name: "Successful" },
    { value: "2", name: "Failed" },
  ];
  const maxStartDate = getSixMonthsAgo();

  // NEW FILTER VARIABLE FIELDS
  const [filterVariables, setFilterVariables] = useState({
    transactionStatus: "-1",
    mobileNumFilter: "",
    paymentCurrencyFilter: "-1",
    paymentIdFilter: "",
    doorSizeFilter: [],
    lockerType: "-1",
    selectedLockerName: [],
    partnerId: "-1",
    startDate: maxStartDate,
    endDate: new Date(),
    endTime: "23:59",
    startTime: "00:00",
  });

  // manage visibility of table
  const [isTableEmpty, setIsTableEmpty] = useState(false);
  const [newNoData, setnewNoData] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [filterButtonClicked, setFilterButtonClicked] = useState(null);
  const [selectedTransStatus, setSelecetedTransStatus] = useState("-1");
  const [showTransactionNumber, setShowRedemptionTransactionNum] =
    useState(false);
  const [allLockersSelected, setAllLockersSelected] = useState(false);
  const [nameData, setNameData] = useState([]);

  // gql queries
  const [
    fetchStorageFeesData,
    { data: storageLazyData, loading: loadingStorageData },
  ] = useLazyQuery(STORAGE_RENTAL_FEES_QUERY);
  const [
    fetchAggregateStorageFees,
    { data: aggregateStorageFees, loading: loadingAggregateData },
  ] = useLazyQuery(AGGREGATE_STORAGE_FEES);

  const [fetchPackage, { data: packageInfo }] = useLazyQuery(FILTER_PACKAGES);
  const [fetchUserId] = useLazyQuery(
    LOCKER_USER_ACCOUNTS_FOR_VIEW_PACKAGE_HISTORY
  );
  const fetchCompanyName = useQuery(QUERY_COMPANY_NKCNAME, {
    variables: {
      operatorId: operatorId,
    },
  });

  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);
  const [fetchLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY,
    {
      variables: {
        operatorId: operatorId,
      },
    }
  );
  const fetchUserType = useQuery(USER_TYPE_FOR_LOCKER_STORAGE_FEES, {
    variables: {
      operatorId: operatorId,
    },
  });
  const { data: allLockerNames } = useQuery(LOCKER_INFO, {
    variables: {
      operatorId: operatorId,
    },
  });

  const findLockerName = (lockerId, nameData) => {
    const locker = nameData.find(
      (locker) => parseInt(locker.lockerId) === parseInt(lockerId)
    );

    return locker ? locker.lockerName : null;
  };

  // table datatable
  const [batchResults, setBatchResults] = useState([]);
  const [pendingBatches, setPendingBatches] = useState(0);
  const [isLoadingBatches, setIsLoadingBatches] = useState(false);
  const isLoading =
    isLoadingBatches || loadingStorageData || loadingAggregateData;

  const findDoorSizes = (doorSizeOptions, doorSizeId) => {
    if (!Array.isArray(doorSizeId) || doorSizeId.length === 0) return [];

    return doorSizeId
      .map((selected) => {
        const match = doorSizeOptions.find(
          (option) => parseInt(option.value) === parseInt(selected.value)
        );
        return match ? match.value : null;
      })
      .filter((value) => value !== null); // remove nulls if no match found
  };

  // validation
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  //date formatter
  function formatDate(inputDate) {
    if (inputDate == null) {
      return "";
    }
    const date = new Date(inputDate);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour12: false,
    };
    return date.toLocaleDateString(undefined, options);
  }

  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) => {
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  useEffect(() => {
    if (allLockerNames && allLockerNames.lockerInfo) {
      const lockerDetails = allLockerNames.lockerInfo.map((locker) => ({
        lockerId: locker.lockerId,
        lockerName: locker.lockerName,
      }));
      setNameData(lockerDetails);
    }
  }, [allLockerNames]);

  useEffect(() => {
    if (filterVariables.lockerType !== "-1") {
      // fetchLockerName({
      // 	operatorId: operatorId,
      // 	selectedLockerType: selectedLockerType,
      // });
      fetchLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: filterVariables.lockerType,
        },
      });
    }
  }, [filterVariables.lockerType, operatorId]);

  useEffect(() => {
    if (lockerNameData) {
      // let tempData = [
      // 	{
      // 		value: "200",
      // 		name: "-- All --",
      // 	},
      // ];
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLockerName(tempData);
    }
  }, [lockerNameData, allLockersSelected]);

  useEffect(() => {
    const selected = filterVariables.selectedLockerName;
    const allLockers = lockerName;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [filterVariables.selectedLockerName, lockerName]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

      // setSelectedLockerName(selectedLockers);
      setFilterVariables({
        ...filterVariables,
        selectedLockerName: selectedLockers,
      });
    }
  }, [allLockersSelected, lockerName]);

  useEffect(() => {
    if (fetchCompanyName.data) {
      let tempData = [];
      fetchCompanyName.data.partners.forEach((element, index) => {
        tempData.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      setPartnerCompany(tempData);
    }
  }, [fetchCompanyName.data]);

  const getDoorId = (doorId) => {
    switch (doorId) {
      case 1:
        return "Small";
      case 2:
        return "Medium";
      case 3:
        return "Large";
      default:
        return "Unknown";
    }
  };

  const togglePaymentIDVisiblity = () => {
    setShowRedemptionTransactionNum(!showTransactionNumber);
  };

  const [storageTableData, setStorageTableData] = useState([]);

  const buildVariables = () => {
    const updatedVariables = {};
    const operatorId = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "";

    // always assign operatorid
    updatedVariables.operatorId = operatorId;

    if (filterVariables.transactionStatus !== "-1") {
      updatedVariables.transactionStatus = filterVariables.transactionStatus;
    }

    if (filterVariables.mobileNumFilter !== "") {
      updatedVariables.mobileNumber = filterVariables.mobileNumFilter;
    }

    if (filterVariables.lockerType !== "-1") {
      updatedVariables.lockerType = filterVariables.lockerType;
    }

    if (filterVariables.selectedLockerName.length !== 0) {
      const lockerIdValues = filterVariables.selectedLockerName.map(
        (locker) => locker.value
      );

      updatedVariables.lockerIds = lockerIdValues;
    }

    if (filterVariables.paymentIdFilter !== "") {
      updatedVariables.paymentId = filterVariables.paymentIdFilter;
    }

    if (filterVariables.doorSizeFilter.length !== 0) {
      updatedVariables.doorSizeId = findDoorSizes(
        doorSizeOptions,
        filterVariables.doorSizeFilter
      );
    }

    if (filterVariables.paymentCurrencyFilter !== "-1") {
      updatedVariables.paymentCurrency =
        filterVariables.paymentCurrencyFilter === "1" ? "PHP" : "PHMC";
    }

    if (filterVariables.startDate) {
      updatedVariables.transactionDateStart = toUTCDateTimeString(
        new Date(filterVariables.startDate),
        filterVariables.startTime || "00:00"
      );
    }

    if (filterVariables.endDate) {
      updatedVariables.transactionDateEnd = toUTCDateTimeString(
        new Date(filterVariables.endDate),
        filterVariables.endTime || "23:59"
      );
    }

    return updatedVariables;
  };

  const handleSearch = () => {
    // setIsLoading(true);
    setIsClicked(true);
    setShowRedemptionTransactionNum(false);
    // setFilterButtonClicked(true);
    handleSearchResultHeader();

    const variable = buildVariables();

    // Case 1: No locker selected
    if (filterVariables.selectedLockerName.length === 0) {
      // If lockerType is not -1, user must pick a locker
      if (filterVariables.lockerType !== "-1") {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Invalid Locker",
          message: `Please select a locker name.`,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });

        // setIsLoading(false);
        setIsClicked(false);
        return;
      }

      // // Else it's okay to proceed with fetchAggregateStorageFees
      fetchAggregateStorageFees({
        variables: variable,
      });
      return;
    }

    // Case 2: Locker name selected → fetch detailed data
    const BATCH_SIZE = 4;
    const selectedLockers = filterVariables.selectedLockerName;
    console.log({ filterVariables, selectedLockers });

    // If 4 or fewer lockers, call once and let useEffect handle it
    if (selectedLockers.length <= BATCH_SIZE) {
      fetchStorageFeesData({
        variables: variable,
      });
      return;
    }

    // For more than 4 lockers, process in batches
    const batches = [];
    for (let i = 0; i < selectedLockers.length; i += BATCH_SIZE) {
      batches.push(selectedLockers.slice(i, i + BATCH_SIZE));
    }

    console.log(`Will process ${batches.length} batches`);

    // Reset batch tracking
    setBatchResults([]);
    setPendingBatches(batches.length);
    setIsLoadingBatches(true);

    // Call fetchOverstayFees for each batch
    batches.forEach((batch, index) => {
      console.log(
        `Calling batch ${index + 1}/${batches.length} with lockers:`,
        batch
      );

      fetchStorageFeesData({
        variables: {
          ...variable,
          lockerIds: batch.map((locker) => locker.value),
        },
      })
        .then((response) => {
          console.log(`Batch ${index + 1} response:`, response);

          if (response?.data?.storageRentalFees) {
            const batchData = response.data.storageRentalFees;
            console.log(`Batch ${index + 1} got ${batchData.length} results`);

            setBatchResults((prev) => [...prev, ...batchData]);
          }

          setPendingBatches((prev) => prev - 1);
        })
        .catch((error) => {
          console.error(`Batch ${index + 1} error:`, error);
          setPendingBatches((prev) => prev - 1);
        });
    });
  };

  function handleSearchResultHeader() {
    const lockerTypeName =
      filterVariables.lockerType === "-1"
        ? "ALL Locker types"
        : filterVariables.lockerType === "1"
        ? "Parcel Locker"
        : "Fridge Locker";

    let lockerNameText;
    if (allLockersSelected) {
      lockerNameText = "ALL Lockers";
    } else {
      const lockerLabels = filterVariables.selectedLockerName
        .map((selectedLocker) => {
          const matchedLocker = lockerName.find(
            (item) => parseInt(item.value) === parseInt(selectedLocker.value)
          );
          return matchedLocker ? matchedLocker.label : null;
        })
        .filter((label) => label !== null);

      lockerNameText =
        lockerLabels.length > 0 ? lockerLabels.join(", ") : "ALL Lockers";
    }

    const transActNameValue =
      filterVariables.transactionStatus === -1 ||
      filterVariables.transactionStatus === "-1"
        ? ""
        : transActStatus.find(
            (item) => item.value === filterVariables.transactionStatus
          );

    const transActNameText =
      transActNameValue !== ""
        ? `${transActNameValue.name} Transactions`
        : "ALL Transaction Status";

    const doorSizeVal =
      filterVariables.doorSizeFilter === 0 ||
      filterVariables.doorSizeFilter.some((item) => item.value === "")
        ? []
        : doorSizeOptions.filter((item) =>
            filterVariables.doorSizeFilter.some(
              (selectedItem) => selectedItem.value === item.value
            )
          );

    const doorSizeText =
      doorSizeVal.length > 0
        ? doorSizeVal.map((item) => item.label).join(", ") + " door sizes"
        : "ALL Door Sizes";

    let partnerCompanyName = "ALL Partners";
    if (selectedPartnerCompany !== "-1" && selectedPartnerCompany !== "") {
      const foundPartnerCompany = partnerCompany.find(
        (item) => item.value.toString() === selectedPartnerCompany
      );
      partnerCompanyName = foundPartnerCompany
        ? foundPartnerCompany.name
        : "ALL Partners";
    }
    const partnerBranchValue =
      selectedPartnerBranch === "-1" || selectedPartnerBranch === ""
        ? "ALL Branches"
        : partnerBranches.find(
            (item) => item.value.toString() === selectedPartnerBranch
          );

    const partnerBranchText =
      partnerBranchValue && typeof partnerBranchValue === "object"
        ? partnerBranchValue.name
        : partnerBranchValue || "ALL Branches";

    // const lockerNameValue =
    // 	selectedLockerName != "200"
    // 		? lockerName.find(
    // 				(item) => item.value.toString() === selectedLockerName
    // 		  )
    // 		: "ALL Lockers";

    const mobileHeader =
      numberFilter !== "" ? numberFilter : "ALL Mobile Numbers";
    setSearchResultHeader(`for
		${transActNameText},
		${lockerTypeName},
    	${lockerNameText},
		${mobileHeader},
		${doorSizeText},
		from ${globalFormatDate(filterVariables.startDate)} to ${globalFormatDate(
      filterVariables.endDate
    )}
    `);
  }

  // handle change filter variables
  const handleFilterChange = (e, field) => {
    setIsClicked(false);
    let value = e.target.value;

    if (field === "startDate" || field === "endDate") {
      value = value ? new Date(value) : null;
    }
    if (field === "lockerType") {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
        selectedLockerName: [],
      });
    } else {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
      });
    }
  };

  useEffect(() => {
    if (!isClicked) return;
    if (filterVariables.selectedLockerName.length !== 0) return;

    if (
      aggregateStorageFees &&
      aggregateStorageFees.aggregateStorageRentalFees
    ) {
      if (aggregateStorageFees.aggregateStorageRentalFees.length > 0) {
        const {
          tableData,
          totalAmt: amt,
          statusBySvc,
          totalTxns,
          grossSales,
        } = computeAggregateFromBackend(
          aggregateStorageFees.aggregateStorageRentalFees,
          nameData,
          findLockerName,
          {
            includeRefunds: true,
          }
        );
        setStorageTableData(tableData);
        setTotalAmt(amt);
        setTotalSuccessTrans(statusBySvc.success);
        setTotalDuplicates(statusBySvc.duplicates);
        setTotalGrossSales(grossSales.subtotal);
        setTotalFailed(statusBySvc.failed);
        setTotalTransactions(totalTxns);
      } else {
        setStorageTableData([]);
      }
    }
  }, [
    aggregateStorageFees,
    nameData,
    isClicked,
    filterVariables.selectedLockerName.length,
  ]);

  console.log({ storageTableData });

  // ONLY handle single queries (≤ 4 lockers) - NOT batch results
  useEffect(() => {
    if (!isClicked) return;
    if (isLoadingBatches) return; // Skip if in batch mode

    if (storageLazyData && storageLazyData.storageRentalFees) {
      const currentResults = storageLazyData.storageRentalFees;
      console.log(`Single query result:`, currentResults);

      if (currentResults.length > 0) {
        const {
          tableData,
          totalAmt: amt,
          statusBySvc,
          totalTxns,
          grossSales,
        } = computeAggregateFromBackend(currentResults, [], nameData, {
          includeRefunds: true,
          forAggregate: false,
        });

        updateTableState(tableData, amt, statusBySvc, totalTxns, grossSales);
      } else {
        // clearTableState();
      }
    }
  }, [storageLazyData, nameData, isClicked, isLoadingBatches]);

  // Handle combined batch results when all batches complete
  useEffect(() => {
    if (!isLoadingBatches || pendingBatches > 0) return;

    console.log(
      `All batches complete! Processing ${batchResults.length} total results`
    );

    if (batchResults.length > 0) {
      const {
        tableData,
        totalAmt: amt,
        statusBySvc,
        totalTxns,
        grossSales,
      } = computeAggregateFromBackend(batchResults, [], nameData, {
        includeRefunds: true,
        forAggregate: false,
      });

      updateTableState(tableData, amt, statusBySvc, totalTxns, grossSales);
    } else {
      // clearTableState();
    }

    // Reset batch state
    setIsLoadingBatches(false);
    setBatchResults([]);
  }, [pendingBatches, isLoadingBatches, batchResults, nameData]);

  // Helper functions
  const updateTableState = (
    tableData,
    amt,
    statusBySvc,
    totalTxns,
    grossSales
  ) => {
    setStorageTableData(tableData);
    setTotalAmt(amt);
    setTotalSuccessTrans(statusBySvc.success);
    setTotalGrossSales(grossSales.subtotal);
    setTotalRefunded(statusBySvc.refunded);
    setTotalDuplicates(statusBySvc.duplicates);
    setTotalFailed(statusBySvc.failed);
    setTotalTransactions(totalTxns);
  };

  const clearTableState = () => {
    setStorageTableData([]);
    setTotalAmt(0);
    setTotalSuccessTrans(0);
    setTotalGrossSales(0);
    setTotalRefunded(0);
    setTotalDuplicates(0);
    setTotalFailed(0);
    setTotalTransactions(0);
  };

  return (
    <ContentContainer containerTitle={"Storage Rental Fees Report"}>
      <>
        <h2 className={"font-bold"}>Transaction Details:</h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className="col-span-1">Transaction Status:</div>
              <Select
                items={transActStatus}
                className={"col-span-2"}
                value={filterVariables.transactionStatus}
                defaultOption={{ value: "-1", name: "--- ALL ---" }}
                onChange={(event) => {
                  handleFilterChange(event, "transactionStatus");
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-12 w-full items-center">
              <div className={"col-span-4"}>
                Sender / Recipient Mobile Number:
              </div>
              <div className={"col-span-1"}>+63</div>
              <InputText
                keyfilter={"int"}
                placeholder={"XXXXXXXXX"}
                useGrouping={false}
                maxLength={10}
                value={filterVariables.mobileNumFilter}
                onChange={(event) => {
                  handleFilterChange(event, "mobileNumFilter");
                }}
                className="col-span-4 px-4 "
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Door Size:</div>
              {/* <Select
								items={lockerName}
								value={selectedLockerName}
								defaultOption={{
									value: "-1",
									name: "-- Select Locker Name --",
								}}
								onChange={(event) => {
									setSelectedLockerName(event.target.value);
								}}
								className={"col-span-2"}
							/> */}
              <MultiSelect
                placeholder="Select..."
                items={doorSizeOptions}
                value={filterVariables.doorSizeFilter}
                onChange={(event) => {
                  handleFilterChange(event, "doorSizeFilter");
                }}
                className={"col-span-2"}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>
          Locker:
          <span className="font-normal text-xs italic ml-2 text-blue-700">
            (to view each transaction, please select locker type and locker name
            from the list)
          </span>
        </h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Locker Type:</div>
              <Select
                items={lockerType}
                value={filterVariables.lockerType}
                defaultOption={{ value: "-1", name: "-- ALL--" }}
                onChange={(event) => {
                  setAllLockersSelected(false);
                  setFilterVariables({
                    ...filterVariables,
                    selectedLockerName: [],
                  });

                  handleFilterChange(event, "lockerType");
                }}
                className={"col-span-2"}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Locker Name:</div>

              <MultiSelect
                items={lockerName}
                placeholder={`${
                  filterVariables.lockerType === "-1"
                    ? "ALL Lockers"
                    : "Select..."
                }`}
                value={filterVariables.selectedLockerName}
                disabled={filterVariables.lockerType === "-1"}
                onChange={(event) => {
                  handleFilterChange(event, "selectedLockerName");
                }}
                className={"col-span-2"}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>
          Payment Details:{" "}
          {/* <span className="font-normal text-xs italic ml-2 text-blue-700">
						(to filter by payment date, please select a locker name)
					</span> */}
        </h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          {/* <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment ID:</div>
              <InputText
                keyfilter={"int"}
                placeholder={"XXXX"}
                className={"col-span-2 px-4"}
                value={filterVariables.paymentIdFilter}
                maxLength={32}
                onChange={(event) => {
                  handleFilterChange(event, "paymentIdFilter");
                }}
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div> */}

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment Currency:</div>
              <Select
                items={paymentCurrency}
                className={"col-span-2"}
                value={filterVariables.paymentCurrencyFilter}
                onChange={(event) => {
                  // setPaymentCurrencyFilter(event.target.value);
                  handleFilterChange(event, "paymentCurrencyFilter");
                }}
                defaultOption={{ value: "-1", name: "-- ALL--" }}
              />
            </div>
          </div>

          {/* <div>Payment Gateway:</div>
					<Select
						defaultOption={{ value: "-1", name: "--- ALL ---" }}
						items={paymentGatewayOptions}
						value={selectedPaymentGateways}
						onChange={(event) => {
							setSelectedPaymentGateway(event.target.value);
						}}
					/> */}

          {/* {filterVariables.selectedLockerName.length !== 0 && ( */}
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment Date filter:</div>
              <PrimereactDateRange
                timeOnly={true}
                className={`col-span-2`}
                startTime={filterVariables.startTime}
                endTime={filterVariables.endTime}
                startDate={filterVariables.startDate}
                endDate={filterVariables.endDate}
                startDateName="startDate"
                endDateName="endDate"
                startTimeName="startTime"
                endTimeName="endTime"
                onChange={(event, fieldName) => {
                  handleFilterChange(event, fieldName);
                }}
                readOnlyInput={true}
                max={new Date()}
                // min={new Date(threeMonthsFromNow.toISOString().split("T")[0])}
                // min={maxStartDate}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>Partner:</h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Partner Name:</div>
              <Select
                items={partnerCompany}
                disabled
                value={filterVariables.partnerId}
                className={"col-span-2"}
                defaultOption={{ value: "-1", name: "--- ALL ---" }}
                onChange={(event) => {
                  handleFilterChange(event, "partnerId");
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>
        </div>

        <div className="grid grid-cols-12 gap-y-2">
          <div className="col-span-8"></div>
          <u
            className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
            onClick={() => {
              const threeMonthsAgo = new Date();
              threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

              setFilterVariables({
                ...filterVariables,
                startDate: maxStartDate,
                endDate: new Date(),
                selectedLockerName: [],
                doorSizeFilter: [],
                transactionStatus: "-1",
                mobileNumFilter: "",
                waybillNumFilter: "",
                lockerType: "-1",
                paymentIdFilter: "",
                paymentCurrencyFilter: "-1",
                endTime: "23:59",
                startTime: "00:00",
              });

              setIsClicked(false);
            }}
          >
            <i className="fas fa-undo my-auto"></i>
            <p className="ml-1">Reset</p>
          </u>
        </div>

        <Button
          value={"Search"}
          // disabled={loadingAggregateData || loadingStorageData}
          disabled={isLoading}
          onClick={handleSearch}
          className={"w-40 h-8 m-5"}
        />
      </>

      {isClicked &&
        (loadingAggregateData || loadingStorageData ? (
          <LoadingComponent />
        ) : storageTableData.length === 0 ? (
          <NoDataFoundTemplate />
        ) : (
          <Card className="mx-4">
            {" "}
            <div className={`${storageTableData.length === 0 ? "hidden" : ""}`}>
              <div className="mt-5">
                {/* <div>
                  <Checkbox
                    disabled={filterVariables.selectedLockerName.length === 0}
                    checked={showTransactionNumber}
                    onChange={togglePaymentIDVisiblity}
                    // label={
                    // 	showRedemptionCodeColumn
                    // 		? "Hide Redemption Code"
                    // 		: "Show Redemption Code"
                    // }
                    label="Show Payment ID"
                  />
                </div> */}

                <DownloadButton dt={dt} csvOnly={true} />

                <div className={" bg-yellow-400 p-2 "}>
                  <div className={"text-center"}>
                    <span>
                      <h1 className={"font-bold"}>
                        STORAGE RENTAL FEES REPORT
                      </h1>
                    </span>
                    <span>
                      <h1 className={"font-bold"}>{searchResultHeader} </h1>
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-2 grid grid-cols-8">
                <div className={`col-span-1`}></div>

                {(filterVariables.paymentCurrencyFilter === "-1" ||
                  filterVariables.paymentCurrencyFilter === "1") && (
                  <div
                    className={`px-2 ${
                      filterVariables.paymentCurrencyFilter === "-1"
                        ? "col-span-3"
                        : "col-span-6"
                    }`}
                    style={{ display: "grid" }}
                  >
                    <TransactionCard
                      forOverstay={true}
                      currencyType={"PHP"}
                      data={storageTableData}
                      totalAmt={totalAmt}
                      totalGrossSales={totalGrossSales}
                      totalTransactions={totalTransactions.total}
                      totalSuccessTrans={totalSuccessTrans}
                      totalFailedTrans={totalFailedTrans}
                      totalRefund={totalRefunded}
                      totalDuplicates={totalDuplicates}
                    />
                  </div>
                )}

                {(filterVariables.paymentCurrencyFilter === "-1" ||
                  filterVariables.paymentCurrencyFilter === "2") && (
                  <div
                    className={`px-2 ${
                      filterVariables.paymentCurrencyFilter === "-1"
                        ? "col-span-3"
                        : "col-span-6"
                    }`}
                    style={{ display: "grid" }}
                  >
                    <TransactionCard
                      forOverstay={true}
                      currencyType={"MBOX COINS"}
                      data={storageTableData}
                      totalAmt={totalAmt}
                      totalTransactions={totalTransactions.total}
                      totalSuccessTrans={totalSuccessTrans}
                      totalFailedTrans={totalFailedTrans}
                      totalGrossSales={totalGrossSales}
                      totalRefund={totalRefunded}
                      totalDuplicates={totalDuplicates}
                    />
                  </div>
                )}
                <div className={`col-span-1`}></div>
              </div>

              {filterVariables.selectedLockerName.length === 0 ? (
                <AggregateStorageRentalFeesTable
                  dt={dt}
                  items={storageTableData}
                  showMorePaymentDetails={showTransactionNumber}
                />
              ) : (
                <StorageRentalTable
                  headers={[
                    { header_name: "Status", header_key: "status" },
                    {
                      header_name: "Valid for Refund?",
                      header_key: "duplicate",
                    },
                    {
                      header_name: "Partner Name",
                      header_key: "partnerName",
                    },

                    { header_name: "Locker Name", header_key: "lockerName" },
                    {
                      header_name: "Sender Mobile",
                      header_key: "senderMobile",
                    },
                    {
                      header_name: "Recipient Mobile",
                      header_key: "recipientMobile",
                    },
                    { header_name: "Storage ID", header_key: "packageId" },

                    { header_name: "Door Size", header_key: "doorsizeId" },
                    {
                      header_name: "Storage Duration",
                      header_key: "storageDuration",
                    },
                    {
                      header_name: "Initial Storage Fee",
                      header_key: "transactionFee",
                    },
                    // Compute lengthOfStay
                    // {
                    //   header_name: "Total Length of Stay",
                    //   header_key: "lengthOfStay",
                    // },
                    // { header_name: "Overstay Fee", header_key: "excessFee" },

                    {
                      header_name: "Total Amount",
                      header_key: "paymentAmount",
                    },
                    { header_name: "Payment ID", header_key: "paymentId" },
                    {
                      header_name: "Payment Date",
                      header_key: "unformattedPaymentDate",
                    },
                    {
                      header_name: "Payment Gateway",
                      header_key: "paymentGateway",
                    },
                  ]}
                  items={storageTableData}
                  dt={dt}
                  showTransactionNumber={showTransactionNumber}
                  dateRange={`${globalFormatDate(
                    new Date(filterVariables.startDate)
                  )} - ${globalFormatDate(new Date(filterVariables.endDate))}`}
                />
              )}
            </div>
          </Card>
        ))}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
};

export default StorageRentals;
